import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { environment } from "../../../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-student-userdata-create",
  templateUrl: "./student-userdata-create.component.html",
  styleUrls: ["./student-userdata-create.component.scss"],
})
export class StudentUserdataCreateComponent implements OnInit {
  public tinyConfig = {
    base_url: '/assets/tinymce',
    suffix: '.min',
    height: 400,
    menubar: true,
    plugins: 'code table link image lists',
    apiKey: '',
    toolbar: 'undo redo | bold italic underline | alignleft aligncenter alignright | bullist numlist | table | link image | code',
  };
  public Form: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;
  isShown: boolean = false;

  constructor(
    private ActivatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router
  ) { }

  ngOnInit() {
    let role = localStorage.getItem("userRole");
    let user = localStorage.getItem("userId");

    this.action = "Submit";
    this.ActivatedRoute.params.subscribe((params) => {
      let id = params["id"];

      if (id) {
        this.loadUserData(id, role, user);
      }
    });

    this.initializeForm();
  }

  initializeForm() {
    this.Form = this.formBuilder.group({
      name: ["", [Validators.required]],
      username: ["", Validators.required],
      status: ["", Validators.required],
      email: ["", [Validators.required, Validators.email]],
      mobilenumber: ["", [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      password: [""], // Password is handled conditionally in validation
      _id: [""],
    });
  }

  loadUserData(id: string, role: string, user: string) {
    this.http
      .get<any>(`${environment.apiUrl}/userdata/${id}`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (data) => {
          if (data.message == "Logged Out!") {
            this.router.navigateByUrl("/auth/login");
            return;
          }

          if (data.data != "") {
            if (role != "super-admin" && data.data.userid != user) {
              this.router.navigateByUrl("/student-details/student-userdata-list");
              return;
            }

            this.action = "Update";

            this.Form.patchValue({
              _id: data.data._id,
              name: data.data.name,
              username: data.data.username,
              email: data.data.email,
              status: data.data.status.toString(), // Convert boolean to string for radio buttons
              mobilenumber: data.data.mobilenumber,
            });

            // Update password validation for update mode
            this.Form.get('password').setValidators(null);
            this.Form.get('password').updateValueAndValidity();
          }
        },
        (err: HttpErrorResponse) => {
          console.error("Error loading user data:", err);
        }
      );
  }

  get f() {
    return this.Form.controls;
  }

  onFormSubmit() {
    this.submitted = true;

    // Set password validation based on action
    if (this.action === 'Submit') {
      this.Form.get('password').setValidators([Validators.required]);
    } else {
      this.Form.get('password').setValidators(null);
    }
    this.Form.get('password').updateValueAndValidity();

    if (this.Form.invalid) {
      return;
    }

    const data = this.prepareFormData();

    if (this.action == "Submit") {
      this.createUser(data);
    } else {
      this.updateUser(data);
    }
  }

  prepareFormData() {
    const formData: any = {
      name: this.Form.value.name,
      username: this.Form.value.username,
      email: this.Form.value.email,
      status: this.Form.value.status,
      mobilenumber: this.Form.value.mobilenumber,
    };

    // Only include password if it has a value
    if (this.Form.value.password) {
      formData.password = this.Form.value.password;
    }

    // Include _id for updates
    if (this.action === "Update") {
      formData._id = this.Form.value._id;
    }

    return formData;
  }

  createUser(data: any) {
    this.http
      .post<any>(`${environment.apiUrl}/userdata/`, data, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (res) => {
          this.handleResponse(res);
        },
        (err: HttpErrorResponse) => {
          this.handleError(err);
        }
      );
  }

  updateUser(data: any) {
    this.http
      .put<any>(`${environment.apiUrl}/userdata/`, data, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (res) => {
          this.handleResponse(res);
        },
        (err: HttpErrorResponse) => {
          this.handleError(err);
        }
      );
  }

  private handleResponse(res: any) {
    if (res.message == "Logged Out!") {
      this.router.navigateByUrl("/auth/login");
      return;
    }

    if (res.status == "500") {
      this.message = res.message;
      this.class = "btn-primary rounded px-1 py-1";
      window.scrollTo(document.documentElement.clientWidth, 0);
    } else {
      this.message = this.action === "Submit" ? "Successfully Added" : "Successfully Updated";
      this.class = "btn-success rounded px-1 py-1";
      this.router.navigateByUrl("/student-details/student-userdata-list");
    }
  }

  private handleError(err: HttpErrorResponse) {
    if (err.error instanceof Error) {
      console.log("Client-side error occurred.");
    } else {
      console.log("Server-side error occurred.");
    }
  }
}